import angular from 'angular'

import CustomerAddressFilter from './vd-customer-address.filter'
import CustomerAuxInfoFilter from './vd-customer-aux-info.filter'
import CustomerNameFilter from './vd-customer-name.filter'

angular
  .module('vend.ui')
  .filter('vdCustomerAddress', CustomerAddressFilter)
  .filter('vdCustomerName', CustomerNameFilter)
  .filter('vdCustomerAuxInfo', CustomerAuxInfoFilter)
